// extracted by mini-css-extract-plugin
module.exports = {"profile":"clinical-portal-3__DropdownUserInfo__profile","name":"clinical-portal-3__DropdownUserInfo__name"};